export default __webpack_public_path__ + "static/media/Q4-extra.476ac770.png";